import React, { useEffect, useMemo, useRef } from 'react';
import { generateKernelLines } from './kernelLines';
import useKernelBoot from './useKernelBoot';
import './boot.css';

const KernelBoot = ({ onComplete }) => {
    const lines = useMemo(() => generateKernelLines(), []);
    const visible = useKernelBoot({
        lineCount: lines.length,
        durationMs: 6000,
        onComplete,
    });

    const parseKernelLine = (line) => {
        const match = line.match(/^\[\s*([\d.]+)\]\s*(.*?)(\s+\[OK\])?$/);

        if (!match) {
            return {raw: line};
        }

        return {
            timestamp: match[1],
            message: match[2],
            status: match[3], 
        };
    };


    const viewportRef = useRef(null);

    useEffect(() => {
        if (viewportRef.current) {
            viewportRef.current.scrollTop = viewportRef.current.scrollHeight;
        }
    }, [visible]);

    return (
        <div className="bootRoot">
            <div className="logViewport" ref={viewportRef}>
                <div className="logText">
                    {lines.slice(0, visible).map((line, i) => {
                        const parsed = parseKernelLine(line);

                        if (parsed.raw) {
                            return (
                                <div key={i} className="line">
                                    {parsed.raw}
                                </div>
                            );
                        }

                        return (
                            <div key={i} className="line">
                                <span className="timestamp">[ {parsed.timestamp} ] </span>
                                <span className="message">{parsed.message}</span>
                                {parsed.status && (
                                    <span className="statusOk">{parsed.status}</span>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default KernelBoot;
